module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.ticketSubmissionResult == null) ? _c('div', {
    staticClass: "ui form"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "field"
  }, [_c('label', [_vm._v("Your Contact E-Mail Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactEmail),
      expression: "contactEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.contactEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactEmail = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category !== 'new_feature'),
      expression: "category !== 'new_feature'"
    }],
    staticClass: "field"
  }, [_c('label', [_vm._v("Summary")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ticketContent),
      expression: "ticketContent"
    }],
    attrs: {
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.ticketContent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ticketContent = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.category !== 'new_feature'),
      expression: "category !== 'new_feature'"
    }],
    staticClass: "two fields"
  }, [_c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("ASIN")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asin),
      expression: "asin"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.asin)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.asin = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', [_vm._v("Marketplace")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.marketplace),
      expression: "marketplace"
    }],
    staticClass: "ui fluid search dropdown",
    attrs: {
      "name": "helpModalMarketplace"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.marketplace = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "US"
    }
  }, [_vm._v("US")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("CA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MX"
    }
  }, [_vm._v("MX")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BR"
    }
  }, [_vm._v("BR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UK"
    }
  }, [_vm._v("UK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("DE")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FR"
    }
  }, [_vm._v("FR")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ES"
    }
  }, [_vm._v("ES")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IT"
    }
  }, [_vm._v("IT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NL"
    }
  }, [_vm._v("NL")])])])]), _vm._v(" "), (_vm.productExistsError) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Error")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.productExistsError))])])]) : _vm._e(), _vm._v(" "), (_vm.productExistsWarning) ? _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "ui negative message"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("Warning")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.productExistsWarning))])])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "ui primary button",
    on: {
      "click": function($event) {
        return _vm.submitTicket()
      }
    }
  }, [_vm._v("Submit")])]) : (_vm.ticketSubmissionResult === true) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "ui large header",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("Thank You for contacting us!")]), _vm._v(" "), _c('span', {
    staticClass: "ui medium header"
  }, [_vm._v("We have received your message and we'll get back to you shortly.")])]) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticClass: "ui medium header",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_vm._v("Something went wrong while processing your message")]), _vm._v(" "), _c('p', {
    staticClass: "ui small header"
  }, [_vm._v("Please e-mail support@sentrykit.com")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f568a3e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpModal.SupportTicketForm.vue
// module id = 771
// module chunks = 2